import { logout } from "../../services/login";
import { userLogout as userLogoutCommonStore } from '../../store/common';
import { userLogout as userLogoutDataStore } from '../../store/data';
import { userLogout } from '../../store/main';
import { userLogout as userLogoutAccountStore } from '../../store/manage/accounts';
import { userLogout as userLogoutBillingStore } from '../../store/manage/billingdetails';
import { userLogout as userLogoutAOSStore } from '../../store/sealing/android';
import { userLogout as userLogoutIOSStore } from '../../store/sealing/ios';
import { AppURL } from '../../utility/AppURL';
import { getCookies, setCookies } from '../../utility/Common';

export const userLogoutFunction = async() => {
	const token = getCookies('appsealing') || "";
	const response = await logout(token);
	if(response?.result?.code === '0000') {
		handleUserLogout();
	}else{
		handleUserLogout();
	}
};

const handleUserLogout = async () => {
    setCookies('DOVERUNNER_AS_TOKEN', '', 'Thu, 01 Jan 1970 00:00:01 GMT');
    setCookies('appsealing', '');
    localStorage.removeItem('okta-jwt');
    sessionStorage.removeItem('FeedbackButtonClosed');

    userLogout(null);
    userLogoutCommonStore(null);
    userLogoutDataStore(null);
    userLogoutAccountStore(null);
    userLogoutBillingStore(null);
    userLogoutAOSStore(null);
    userLogoutIOSStore(null);
    window.location.href = AppURL.doverunnerLogout;
};
